export enum ContactFormValuesEnum {
	PROSPECT_TYPE = 'prospectType',
	CIVILITY = 'civility',
	LASTNAME = 'lastname',
	FIRSTNAME = 'firstname',
	EMAIL = 'email',
	MOBILE = 'mobile',
	SOCIAL_REASON = 'socialReason',
	ORIGIN = 'origin'
}